import useArraySearchParam, {
  ArraySearchParamActions,
} from './useArraySearchParam';

export default function useIntArraySearchParam(
  name: string
): [number[], ArraySearchParamActions<number>] {
  return useArraySearchParam<number>(name, {
    initialize: (s: string[]): number[] =>
      s.filter((v) => v).map((v) => parseInt(v, 10)),
  });
}
